import { memo, useMemo, useState } from 'react'
import { Grid, Menu, MenuItem, MenuList } from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import findIndex from 'lodash/findIndex'

import { useStyles } from './styles'

const getSelectedOption = (options, selectedValue, valueName, optionsColor) => {
   const optionIdx = findIndex(options, { [valueName]: selectedValue })
   const selectedOption = options?.[optionIdx] ?? {}
   selectedOption.color = optionsColor?.[optionIdx]
   return selectedOption
}

const StatusSelector = ({
   selectedValue,
   options = [],
   onChange,
   optionsColor = ['success', 'danger'],
   label = 'label',
   valueName = 'value',
   disabled
}) => {
   const [anchorEl, setAnchorEl] = useState(null)
   const selectedOption = useMemo(
      () => getSelectedOption(options, selectedValue, valueName, optionsColor),
      [selectedValue, options, valueName, optionsColor]
   )

   const classes = useStyles({
      color: selectedOption?.color,
      menuWidth: anchorEl?.clientWidth,
      disabled
   })
   const isOpen = Boolean(anchorEl)

   const handleClick = event => {
      !disabled && setAnchorEl(event.currentTarget)
   }

   const handleSelect = value => {
      onChange(value)
   }

   return (
      <Grid container className={classes.container}>
         <Grid className={classes.statusSelector} onClick={handleClick}>
            <span className={classes.led}></span>
            <span>{selectedOption?.[label] ?? '---'}</span>
            {disabled ? <span></span> : isOpen ? <ExpandLess /> : <ExpandMore />}
         </Grid>
         <Menu
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            getContentAnchorEl={null}
            anchorOrigin={{
               vertical: 'bottom',
               horizontal: 'left'
            }}
            transformOrigin={{
               vertical: 'top',
               horizontal: 'left'
            }}
         >
            <MenuList className={classes.menulist}>
               {options?.map(option => (
                  <MenuItem key={option?.[valueName]} onClick={() => handleSelect(option[valueName])}>
                     {option?.[label]}
                  </MenuItem>
               ))}
            </MenuList>
         </Menu>
      </Grid>
   )
}

export default memo(StatusSelector)
